import { CSSProperties, useEffect, useState } from "react"
import { Column, ColumnPinningState, Header } from "@tanstack/react-table"

const readPinned = (storageKey: string): string[] => {
  try {
    const stored = localStorage.getItem(storageKey)
    const parsed = stored ? JSON.parse(stored) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export const useColumnPinning = (storageKey: string) => {
  const [columnPinning, setColumnPinning] = useState<ColumnPinningState>({ left: [], right: [] })

  useEffect(() => {
    const pinned = readPinned(storageKey)
    if (pinned.length > 0) setColumnPinning({ left: pinned, right: [] })
  }, [storageKey])

  const togglePin = (header: Header<any, unknown>, pinStatus: "left" | false = false) => {
    header.column.pin(pinStatus)

    const current = readPinned(storageKey)
    const next =
      pinStatus === "left"
        ? current.includes(header.column.id)
          ? current
          : [...current, header.column.id]
        : current.filter((id) => id !== header.column.id)

    localStorage.setItem(storageKey, JSON.stringify(next))
  }

  return { columnPinning, setColumnPinning, togglePin }
}

export const getCellPinningStyles = (column: Column<any>): CSSProperties => {
  const isPinned = column.getIsPinned()
  return {
    boxShadow: isPinned ? "-4px 0 4px -4px gray inset" : undefined,
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? "sticky" : undefined,
    zIndex: isPinned ? 1 : undefined,
    background: isPinned ? "white" : undefined,
  }
}

export const getHeaderPinningStyles = (column: Column<any>): CSSProperties => {
  const isPinned = column.getIsPinned()
  return {
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    boxShadow: isPinned ? "-4px 0 4px -4px gray inset" : undefined,
    opacity: isPinned ? 0.95 : 1,
    zIndex: isPinned ? 31 : 30,
  }
}
